import React, { useState } from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../../assets/svg/icons/common/CaretRight";
import Download from "../../../../../../../assets/svg/icons/common/Download";
import ChildTable from "./ChildTable";
import { dateFormatter, formatCurrency } from "../../../../../../../../components/helper/helper";

function Row({ data, onDownload, isDownloading, isAnyDownloading }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <tr className={style.table_row}>
        <td className={style.table_cell}>
          <ButtonIcon
            bgColor={"#FF"}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className={`${isOpen ? style.collapse_button : ""}`}
          >
            <CaretRight />
          </ButtonIcon>
        </td>
        <td className={style.table_cell}>
          {data?.batch_date ? dateFormatter(data?.batch_date) : '-'}
        </td>
        <td className={style.table_cell}>{data?.batch_number}</td>
        <td className={style.table_cell}>{data?.terminal_id}</td>
        <td className={style.table_cell}>{data?.trans_cnt}</td>
        <td className={style.table_cell}>{data?.key_entry_cnt}</td>
        <td className={style.table_cell}>{data?.sales ? `$ ${formatCurrency(data?.sales)}` : '0'}</td>
        <td className={style.table_cell}>{data?.returns ? `$ ${formatCurrency(data?.returns)}` : '0'}</td>
        <td className={style.table_cell}>$ {data?.net_amt ? formatCurrency(data?.net_amt) : '0.00'}</td>
        <td className={style.table_cell}>{data?.adjustment_amt ? `$ ${formatCurrency(data?.adjustment_amt)}` : '0'}</td>
        <td className={style.table_cell}>
          <ButtonIcon
            bgColor="#EDEDF4"
            title="Download this batch with related chargebacks and residuals"
            disabled={isDownloading || isAnyDownloading}
            onClick={(e) => {
              e.stopPropagation();
              onDownload(data);
            }}
          >
            <Download />
            <span>{isDownloading ? "Downloading..." : "Download"}</span>
          </ButtonIcon>
        </td>
      </tr>
      {isOpen && <ChildTable data={data?.batches_data_details} />}
    </>
  );
}

export default Row;
